import StorySource from '../../data/story-source';
import LocalStorage from '../../data/local-storage';

export default class AuthModel {
  constructor() {
    this.isAuthenticated = false;
    this.currentForm = 'login';
  }

  loadUserState() {
    const token = LocalStorage.getItem('heliaedu_token');
    const userData = LocalStorage.getItem('heliaedu_user');
    
    if (token && userData) {
      this.isAuthenticated = true;
      return true;
    }
    
    this.isAuthenticated = false;
    return false;
  }

  async loginUser(email, password) {
    const response = await StorySource.login(email, password);
    
    if (!response.error) {
      const token = response.loginResult.token;
      const user = {
        id: response.loginResult.userId,
        name: response.loginResult.name,
        email: email
      };

      LocalStorage.setItem('heliaedu_token', token);
      LocalStorage.setObject('heliaedu_user', user);

      this.isAuthenticated = true;
      
      return {
        success: true,
        token,
        user
      };
    }
    
    throw new Error(response.message || 'Login failed');
  }

  async registerUser(name, email, password) {
    const response = await StorySource.register(name, email, password);
    
    if (!response.error) {
      return {
        success: true,
        message: response.message || 'Registration successful'
      };
    }
    
    throw new Error(response.message || 'Registration failed');
  }

  validateLoginForm(email, password) {
    if (!email || !password) {
      return { valid: false, message: 'Mohon lengkapi semua field' };
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return { valid: false, message: 'Format email tidak valid' };
    }

    return { valid: true };
  }

  validateRegisterForm(name, email, password) {
    if (!name || !email || !password) {
      return { valid: false, message: 'Mohon lengkapi semua field' };
    }

    if (name.length < 2) {
      return { valid: false, message: 'Nama minimal 2 karakter' };
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return { valid: false, message: 'Format email tidak valid' };
    }

    if (password.length < 8) {
      return { valid: false, message: 'Password minimal 8 karakter' };
    }

    return { valid: true };
  }

  getCurrentForm() {
    return this.currentForm;
  }

  setCurrentForm(form) {
    this.currentForm = form;
  }

  isUserAuthenticated() {
    return this.isAuthenticated;
  }
}